(function () {
  const sections = document.querySelectorAll('[data-landing-wavelength]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const tabs = section.querySelectorAll('[data-wavelength-tab]');
    const panels = section.querySelectorAll('[data-wavelength-panel]');

    if (!tabs.length) return;

    const activate = (mode) => {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.wavelengthTab === mode;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.wavelengthPanel === mode;
        panel.classList.toggle('is-active', isActive);

        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activate(tab.dataset.wavelengthTab);
      });

      tab.addEventListener('keydown', (event) => {
        const currentIndex = Array.from(tabs).indexOf(tab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (currentIndex + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else {
          return;
        }

        event.preventDefault();
        tabs[nextIndex].focus();
        activate(tabs[nextIndex].dataset.wavelengthTab);
      });
    });

    activate('blue');
  });
})();
